
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class TaskActionDtoModel extends Model<TaskActionDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'details', type: 'string' },
		{ name: 'inquiryReply', type: 'string' },
		{ name: 'taskAreaId', type: 'string' },
		{ name: 'plannedDate', type: 'Date' },
		{ name: 'dateOnly', type: 'boolean' },
		{ name: 'userId', type: 'string' }
	];
	[key: string]: any;
	
	public details: string;
	public inquiryReply: string;
	public taskAreaId?: string;
	public plannedDate?: Date;
	public dateOnly?: boolean;
	public userId?: string;
    
	constructor(){
		super();
		this.details = '';
		this.inquiryReply = '';
		this.taskAreaId = undefined;
		this.plannedDate = undefined;
		this.dateOnly = undefined;
		this.userId = undefined;
		
	}
	getProperties(){
		return TaskActionDtoModel.classProperties;
	}
}

